import RestService from "@/services/RestService";

function createChart(studentLessonId) {
  const data = {
    student_lesson: studentLessonId,
  };
  return RestService.sendReq("post", "chat_room", data);
}

function _createReq(chatId, text, file, studentLessonId) {
  const formData = new FormData();
  formData.append("chat_room_id", chatId);
  formData.append("text", text);
  formData.append("studentLessonId", studentLessonId);
  if (file && file.size && file.size !== 0) {
    formData.append("file", file);
  }

  return formData;
}

function sendMessage(chatId, text, file, studentLessonId) {
  const data = _createReq(chatId, text, file, studentLessonId);

  return RestService.sendReq("post", "message", data);
}
function getChartMessages(chatId) {
  const data = {};
  return RestService.sendReq("get", `chat_room/${chatId}`, data);
}

function removeMessageById(messageId) {
  const data = {};
  return RestService.sendReq("delete", `message/${messageId}`, data);
}

function markAsRead(ids, studentLessonId) {
  const data = { ids, studentLessonId };
  return RestService.sendReq("post", `mark_as_read`, data);
}
function getUnreadMessages() {
  return RestService.sendReq("get", "unread_messages", {});
}
export default {
  createChart,
  sendMessage,
  removeMessageById,
  getChartMessages,
  getUnreadMessages,
  markAsRead,
};
